import React from "react";
import { ObserveState } from "../StateManagement/ObserveState";
import { StateManager } from "../../rule-engine-core/Common/StateManager";
import { SxProps } from "@mui/material";
import { UISelect } from "../BuildlingBlocks/UISelect";
import { getPropertyEditorValidationIssues, PropertyEditorValidationTooltip } from "./PropertyEditorValidationTooltip";

export interface PropertyEditorSelectInterface {
    editObject: object;
    label?: string;
    propertyName: string;
    options: string[];
    hint?: string;
    requiredText?: string;
    parentDefaultValue?: string;
    onChange?: () => void;
    sx?: SxProps;
    error?: string;
    ignoreDesignerValidation?: boolean;
}

export const PropertyEditorSelect: React.FC<PropertyEditorSelectInterface> = (props: PropertyEditorSelectInterface) => {
    const onChange = (v: string | undefined) => {
        if (props.parentDefaultValue && props.parentDefaultValue === v) {
            Reflect.set(props.editObject, props.propertyName, undefined);
        } else {
            Reflect.set(props.editObject, props.propertyName, v);
        }
        StateManager.propertyChanged(props.editObject, props.propertyName);
        if (props.onChange) props.onChange();
    };

    return (
        <ObserveState
            listenTo={props.editObject}
            properties={[props.propertyName]}
            control={() => {
                let validationIssues = getPropertyEditorValidationIssues(
                    props.editObject,
                    props.propertyName,
                    props.error,
                );
                return (
                    <PropertyEditorValidationTooltip
                        editObject={props.editObject}
                        propertyName={props.propertyName}
                        error={validationIssues}
                    >
                        <UISelect
                            label={props.label}
                            value={Reflect.get(props.editObject, props.propertyName) ?? props.parentDefaultValue}
                            options={props.options}
                            onChange={onChange}
                            hint={props.hint}
                            error={validationIssues?.message}
                            sx={{ width: "100%", ...props.sx }}
                        />
                    </PropertyEditorValidationTooltip>
                );
            }}
        />
    );
};
